module.exports = __webpack_public_path__ + "static/media/Assets.d2f59b71.png";